import React from 'react';

// Mobile Share App — stacked QR cards; hand the phone over to be scanned, or share.
export default function ShareAppMobile({ vm }) {
  const { links, canShare, copy, share, whatsapp, download } = vm;
  return (
    <div>
      <div className="page-head">
        <h1>Share App</h1>
      </div>
      <div className="mobile-card-list">
        {links.map(link => (
          <div key={link.key} className="card card-pad mobile-record-card share-qr-card">
            <strong className="mobile-title">{link.title}</strong>
            <div className="share-qr-box">
              {link.qr ? <img src={link.qr} alt={`QR code: ${link.url}`} /> : <span className="muted">Drawing…</span>}
            </div>
            <div className="muted" style={{ fontSize: 13 }}>{link.hint}</div>
            <div className="share-qr-url">{link.url}</div>
            <div className="share-qr-actions">
              {canShare
                ? <button className="btn primary" onClick={() => share(link)}>Share</button>
                : <button className="btn primary" onClick={() => whatsapp(link)}>WhatsApp</button>}
              <button className="btn" onClick={() => copy(link)}>Copy link</button>
              <button className="btn" onClick={() => download(link)} disabled={!link.qr}>Save QR</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
